import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { debounceTime, fromEvent, map, Observable, retry } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CourseService {
  private apiCourseUrl = "/courses";
  private apiCourseReviewUrl = "/course_reviews";
  private apiCourseCategoriesUrl = "/course_categories";
  private apiStudentCoursesUrl = "/student_courses";
  private apiStudentCourseLastedUrl = "/students/course_lasted";
  private apiCourseFileUrl = "/course_files";
  private apiStudentCourseActivateUrl = "/student_courses/activated/";

  #http = inject(HttpClient);

  _setFilter(obj: any) {
    return Object.fromEntries(
      Object.entries(obj).filter(([_, v]) => v != null),
    );
  }

  _setParams(value: any) {
    if (!value) return;
    const filter: any = this._setFilter(value);
    let params = new HttpParams();
    for (const key in filter) {
      if (Array.isArray(filter[key])) {
        params = params.append(key, JSON.stringify(filter[key]));
      } else {
        params = params.append(key, filter[key]);
      }
    }
    return params;
  }

  getCourses(filter?: any) {
    const params = this._setParams(filter) || "";
    return this.#http.get<any>(`${this.apiCourseUrl}?${params}`).pipe(retry(1));
  }
  getCourse(id: number) {
    return this.#http.get<any>(`${this.apiCourseUrl}/${id}`).pipe(retry(1));
  }
  getCoursePublic(id: number) {
    return this.#http
      .get<any>(`${this.apiCourseUrl}/public/${id}`)
      .pipe(retry(1));
  }
  getCourseFiles(filter?: any) {
    const params = this._setParams(filter) || "";
    return this.#http
      .get<any>(`${this.apiCourseFileUrl}?${params}`)
      .pipe(retry(1));
  }

  getStudentCourse(filter?: any) {
    const params = this._setParams(filter) || "";
    return this.#http
      .get<any>(`${this.apiStudentCoursesUrl}?${params}`)
      .pipe(retry(1));
  }
  getStudentCourseById(id: number) {
    return this.#http
      .get<any>(`${this.apiStudentCoursesUrl}/${id}`)
      .pipe(retry(1));
  }
  getStudentCourseLasted(filter?: any) {
    const params = this._setParams(filter) || "";
    return this.#http
      .get<any>(`${this.apiStudentCourseLastedUrl}?${params}`)
      .pipe(retry(1));
  }

  getCourseCategories(filter?: any) {
    const params = this._setParams(filter) || "";
    return this.#http
      .get<any>(`${this.apiCourseCategoriesUrl}?${params}`)
      .pipe(retry(1));
  }
  getCourseCategory(id: number) {
    return this.#http
      .get<any>(`${this.apiCourseCategoriesUrl}/${id}`)
      .pipe(retry(1));
  }

  getCourseReview(filter?: any) {
    const params = this._setParams(filter) || "";
    return this.#http
      .get<any>(`${this.apiCourseReviewUrl}?${params}`)
      .pipe(retry(1));
  }

  activateCourse(id: any): Observable<any> {
    return this.#http
      .put<any>(`${this.apiStudentCourseActivateUrl}${id}`, {})
      .pipe(retry(1));
  }
}
